import React, { useState } from 'react';
import { FiTrash2, FiEdit2 } from 'react-icons/fi';
import EditEvent from './EditEventProvider';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Card = styled.div`
  border: 1px solid #ccc;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background-color: #fdfdfd;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h4`
  color: #385963;
  margin: 0 0 0.5rem 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Comment = styled.p`
  margin: 0.5rem 0;
  font-style: italic;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const IconGroup = styled.div`
  display: flex;
  gap: 1rem;

  svg {
    cursor: pointer;
    font-size: 1.1rem;
  }

  .edit {
    color: #385963;
  }

  .delete {
    color: #e60000;
  }
`;

const SectionTitle = styled.h3`
  color: #385963;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

const RequestsCard = ({ eventsReq, onEditEvent }) => {
  const { i18n } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const tokenString = sessionStorage.getItem('token');
  const [editingEvent, setEditingEvent] = useState(null);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this Event?')) {
      try {
        await fetch(`${BASE_URL}Event/${id}`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${tokenString}`,
          },
        });
        window.location.reload();
      } catch (err) {
        console.error('Error deleting Event:', err);
      }
    }
  };

  const handleSaved = () => {
    setEditingEvent(null);
    window.location.reload();
  };

  if (editingEvent) {
    return (
      <EditEvent
        event={editingEvent}
        onCancel={() => setEditingEvent(null)}
        onSaved={handleSaved}
      />
    );
  }

  const pendingEvents = eventsReq?.filter((e) => e.status === 0) || [];
  const forRevisionEvents = eventsReq?.filter((e) => e.status === 3) || [];

  return (
    <div>
      <SectionTitle>{i18n.t('pending')}</SectionTitle>
      {pendingEvents.length === 0 ? (
        <p>{i18n.t('noRequests')}</p>
      ) : (
        pendingEvents.map((event) => (
          <Card key={`pending-${event.id}`}>
            <Header>
              <div>
                <Title>{event.name?.gr} / {event.name?.en}</Title>
                <Comment>
                  <strong>{i18n.t('adminComment')}:</strong> {event.comment || '—'}
                </Comment>
              </div>
              <IconGroup>
                <FiEdit2 className="edit" onClick={() => onEditEvent?.(event)} />
                <FiTrash2 className="delete" onClick={() => handleDelete(event.id)} />
              </IconGroup>
            </Header>
          </Card>
        ))
      )}

      <SectionTitle>{i18n.t('forRevision')}</SectionTitle>
      {forRevisionEvents.length === 0 ? (
        <p>{i18n.t('noRequests')}</p>
      ) : (
        forRevisionEvents.map((event) => (
          <Card key={`forrevision-${event.id}`}>
            <Header>
              <div>
                <Title>{event.name?.gr} / {event.name?.en}</Title>
                <Comment>
                  <strong>{i18n.t('adminComment')}:</strong> {event.comment || '—'}
                </Comment>
              </div>
              <IconGroup>
                <FiEdit2 className="edit" onClick={() => onEditEvent?.(event)} />
                <FiTrash2 className="delete" onClick={() => handleDelete(event.id)} />
              </IconGroup>
            </Header>
          </Card>
        ))
      )}
    </div>
  );
};

export default RequestsCard;
